import { contacts } from '../config/site';
import { SiteFooter } from './SiteFooter';

export function Contact() {
  return (
    <section className="contact" id="contact" aria-labelledby="contact-title">
      <div className="page-shell section-frame" data-reveal>
        <div className="section-kicker">
          <span className="eyebrow">Начнём с разговора</span>
          <span>Напишите — разберём задачу и следующий шаг.</span>
        </div>

        <h2 id="contact-title">Есть задача?<br /><em>Обсудим.</em></h2>

        <div className="contact-row">
          <p>Расскажите, что хотите запустить или улучшить. Я посмотрю задачу и предложу понятный следующий шаг.</p>
          <address className="contact-links" aria-label="Контакты">
            <a href={contacts.emailHref}><span>Email</span>{contacts.email}</a>
            <a href={contacts.instagramHref} target="_blank" rel="noreferrer"><span>Instagram</span>{contacts.instagram}</a>
            <a href={contacts.phoneHref}><span>Телефон</span>{contacts.phone}</a>
          </address>
        </div>

        <a className="primary-action action-link contact-action" href={contacts.emailHref}>Обсудить проект <span aria-hidden="true">→</span></a>

        <SiteFooter />
      </div>
    </section>
  );
}
